import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { getStoredState, persistReducer, persistStore } from "redux-persist";
import { persistStorage } from "@lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import createSagaMiddleware from "redux-saga";
import middlewares from "../middlewares";
import reducers from "../reducers";

import { rootSaga } from "../sagas";

const getInitialState = (latestState) => {
  return Object.keys(reducers).reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: { ...latestState[curr], ...reducers[curr]?.initialState },
    }),
    {},
  );
};

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers =
  (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const persistConfig = {
  key: "root",
  storage: persistStorage,
  whitelist: ["auth", "customer"],
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers(reducers),
);
const appReducer = persistedReducer;

const rootReducer = (stateParam, action) => {
  let state = stateParam;
  if (action.type === "RESET_REDUX") {
    state = { ...state, ...getInitialState(state) };
  }
  return appReducer(state, action);
};

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware, ...middlewares)),
);

sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);

const getStateInPersist = () => getStoredState(persistConfig);

export { getStateInPersist, persistor, store };
